module.exports = __webpack_public_path__ + "static/media/marina.266b829c.png";